export default "__VITE_ASSET__CVXKD92P__"